import GroupPopup from "./GroupPopup";
import { useEffect, useState } from "react";

export default function Group(props) {
  const [color, setColor] = useState("#fff");
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if ((props.index + 1) % 2 == 0) {
      setColor("#eaf5fd");
    }
  }, []);

  return (
    <>
      <div
        onClick={() => {
          window.location.href = `/group/${props.item.Type}/${props.item.Name}`;
        }}
        style={{ backgroundColor: color }}
        className="row"
      >
        <p>{(props.page-1) * 12 + props.index + 1}</p>
        <p>{props.item.Name}</p>
        <p>{props.item.Type}</p>
        <p>
          {
            new Date(props.item.createdAt).toLocaleDateString('en-GB')
              .toString()
              .split(" GMT")[0]
          }
        </p>
      </div>
      {clicked && (
        <GroupPopup
          refresh={props.refresh}
          setRefresh={props.setRefresh}
          item={props.item}
          setClicked={setClicked}
          url={props.url}
        />
      )}
    </>
  );
}
